import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authApi } from '../../utils/api';

const navItems = [
  { path: '/',                label: 'Dashboard',         icon: '⬡', exact: true },
  { path: '/clients',         label: 'Clients',            icon: '◈' },
  { path: '/podcasts',        label: 'Podcasts',           icon: '🎙' },
  { path: '/send',            label: 'Send EOW / Podcasts',icon: '📧' },
  { path: '/podcast-matcher', label: 'Podcast Matcher',    icon: '✦' },
  { path: '/master-list',     label: 'Master List',        icon: '☰' },
  { path: '/pitch-generator', label: 'Pitch Generator',    icon: '✎' },
  { path: '/leads',           label: 'Leads',              icon: '◎' },
  { path: '/form-filling',    label: 'Form Filling',        icon: '📋', localOnly: true },
  { path: '/settings',        label: 'Settings',           icon: '⚙' },
];

export default function Sidebar() {
  const auth = useAuth();
  // Form Filling opens a visible local browser and needs a human physically
  // present to sign in — can't work on the hosted VPS. loginRequired is only
  // ever true there, so it doubles as the "are we hosted" signal.
  const items = navItems.filter(item => !item.localOnly || !auth?.loginRequired);

  const handleLogout = () => {
    authApi.logout().then(() => window.location.reload());
  };

  return (
    <aside style={{
      width: 'var(--sidebar-w)', background: 'var(--bg-card)',
      borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column',
      flexShrink: 0, height: '100vh', position: 'sticky', top: 0
    }}>
      <div style={{ padding: '24px 20px 20px', borderBottom: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 34, height: 34, background: 'var(--accent)', borderRadius: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 16, fontWeight: 700, fontFamily: 'Syne, sans-serif', flexShrink: 0, color: '#fff'
          }}>P</div>
          <div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 16, letterSpacing: '-0.03em', lineHeight: 1 }}>PitchFlow</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 2, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Podcast PR</div>
          </div>
        </div>
      </div>

      <nav style={{ flex: 1, padding: '12px 10px', display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map(item => (
          <NavLink key={item.path} to={item.path} end={item.exact}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '9px 12px', borderRadius: 'var(--radius-sm)',
              color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
              background: isActive ? 'var(--bg-elevated)' : 'transparent',
              textDecoration: 'none', fontSize: 13,
              fontWeight: isActive ? 500 : 400, transition: 'all 0.15s',
              borderLeft: isActive ? '2px solid var(--accent)' : '2px solid transparent'
            })}>
            <span style={{ fontSize: 15, width: 18, textAlign: 'center' }}>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)' }}>
        {auth?.loginRequired ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{auth.email}</div>
            <button onClick={handleLogout} style={{
              background: 'none', border: 'none', padding: 0, cursor: 'pointer',
              fontSize: 11, color: 'var(--text-muted)', textAlign: 'left', textDecoration: 'underline'
            }}>Sign out</button>
          </div>
        ) : (
          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>v1.0.0 — Local</div>
        )}
      </div>
    </aside>
  );
}
